<!-- eslint-disable max-len -->
<template>
  <div class="main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll">

    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div
          class="bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
        >
          <h5 class="font-bold uppercase text-gray-600">Earnings </h5>
        </div>
        <div class="overflow-y-auto">
          <div style="margin-bottom: 10px">
            <el-row class="px-5 py-2 " >
              <el-col :span="6" class="flex flex-col">
                <span class="text-left">Filter Date</span>
                <vue-monthly-picker
                  v-model="selectedMonth"
                  :monthLabels="monthLabels"
                  :selectedBackgroundColor="'#1a202c'"
                  :clearOption="false"
                  :max="maxMonth"
                  :min="minMonth"
                  @selected="onChangeDate"
                >
                </vue-monthly-picker>
              </el-col>
              <el-col :span="18" class="flex flex-row justify-end">
                <el-row class="flex">
                  <div class="bg-transparent w-64">
                    <div class="card cursor-pointer border border-gray-400 rounded-lg">
                      <div class="m-3">
                        <h2 class="text-xs text-center font-bold mb-2 border-b border-black mb-3">Pending Payout</h2>
                        <div class="text-4xl text-center text-black font-bold">${{data.payout_status=="Pending"?data.payout:0}}</div>
                      </div>
                    </div>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </div>

          <table class="border table-auto w-full">
            <thead>
              <tr class="bg-gray-400 text-gray-600 uppercase text-xs leading-normal">
                <th class="py-3 px-6 text-left">Item</th>
                <th class="py-3 px-6 text-left">Revenue</th>
              </tr>
            </thead>
            <tbody class="text-black text-xs font-light">
            <tr class="border-b border-gray-200 hover:bg-gray-100">
              <td class="py-3 px-6 text-left">Paid Content</td>
              <td class="py-3 px-6 text-left">${{data.paid_content}}</td>
            </tr>
            <tr class="border-b border-gray-200 hover:bg-gray-100">
              <td class="py-3 px-6 text-left">Stream</td>
              <td class="py-3 px-6 text-left">${{data.stream}}</td>
            </tr>
            <tr class="border-b border-gray-200 hover:bg-gray-100">
              <td class="py-3 px-6 text-left">Payout</td>
              <td class="py-3 px-6 text-left">${{data.payout}}</td>
            </tr>
            <tr class="border-b border-gray-200 hover:bg-gray-100">
              <td class="py-3 px-6 text-left">Status</td>
              <td class="py-3 px-6 text-left">{{data.payout_status}}</td>
            </tr>
            <tr class="border-b border-gray-200 hover:bg-gray-100">
              <td class="py-3 px-6 text-left">Payout Date</td>
              <td class="py-3 px-6 text-left">{{data.payout_date}}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import VueMonthlyPicker from 'vue-monthly-picker';
import helperMixins from '../mixins/helpers.mixins';
import moment from 'moment';

const displayingItems = 50;

export default {
  name: 'EarningPage',
  mixins: [helperMixins],
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      selectedMonth: moment(),
      maxMonth: moment(),
      minMonth: moment().subtract(3, 'months'),
      data: {
        paid_content: 0,
        stream: 0,
        payout: 0,
        payout_status: '',
        payout_date: '',
      },
      filter: {
        month: moment().format('YYYY-MM'),
      },
      monthLabels: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestArtistEarningSummary(this.filter);
  },
  computed: {
    ...mapGetters('TransactionModule', ['artistEarningSummary']),
  },
  watch: {
    artistEarningSummary: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (val !== null) {
          let date = '';
          if (val.payout_date !== '') {
            if (this.utc_offset < 0) {
              date = moment(val.payout_date).subtract(Math.abs(this.utc_offset), 'hour');
            } else {
              date = moment(val.payout_date).add(this.utc_offset, 'hour');
            }
          }
          this.data = {
            paid_content: this.formatPrice(parseFloat(this.toDollar(val.paid_content)).toFixed(2)),
            stream: this.formatPrice(parseFloat(val.stream).toFixed(2)),
            payout: this.formatPrice(parseFloat(val.payout).toFixed(2)),
            payout_status: val.payout_status,
            payout_date: date,
          };
        }
        // if(this.listRevenue.data!==undefined){
        //   this.data = this.listRevenue.data.data.map(credit=>{
        //     return {...credit,price_dollar_text:`$${parseFloat(credit.price_dollar).toFixed(2)}`}
        //   });
        //   this.total = this.listRevenue.data.total;
        // }
      },
    },
  },
  methods: {
    ...mapActions('TransactionModule', ['requestArtistEarningSummary']),
    async search() {
      await this.requestArtistEarningSummary(this.filter);
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    async reset() {
      this.filter = {
        month: moment().format('YYYY-MM'),
      };
      this.search();
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        month: moment(res).format('YYYY-MM'),
      };
      await this.search();
    },
  },
  components: {
    VueCustomTooltip, VueMonthlyPicker,
  },
};
</script>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
.vue-daterange-picker .reportrange-text{
  padding: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Earning.vue